(() => {
  const backorderVendors = [
    "Clay Imports Breeze Block",
    "Clay Imports Clay Production",
    "Clay Imports Hecho a Mano",
    "Clay Imports Organic Paver",
    "Clay Imports Organic Terracotta",
    "Clay Imports Organic Tile",
    "Clay Imports Paver",
    "Clay Imports Pressed Terracotta Tile",
    "Clay Imports Printed",
    "Clay Imports Solid Tile",
    "Clay Imports Terracotta Tile"
  ];

  const variantInput = document.querySelector('input[name="id"]');
  const qtyInput = document.querySelector('input[name="quantity"]');
  const submitBtn = document.querySelector('.js-product-calculator-atc');
  const labelSpan = submitBtn?.querySelector('.js-product-calculator-atc-text');

  if (!variantInput || !qtyInput || !submitBtn || !labelSpan || !window.productData) return;

  // --- Modal: inject once ---
  function ensureBackorderModal() {
    if (document.getElementById('ci-backorder-popup')) return;

    // CSS
    if (!document.getElementById('ci-backorder-popup-styles')) {
      const css = `
        .ci-pop-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,.45);
          display: none; align-items: center; justify-content: center;
          z-index: 999999;
        }
        .ci-pop {
          background: #fff; color: #111; max-width: 560px; width: 92vw;
          padding: 24px; border-radius: 0; box-shadow: 0 10px 30px rgba(0,0,0,.25);
          line-height: 1.45; font-size: 16px; letter-spacing:.2px;
        }
        .ci-pop h3 { margin: 0 0 12px; font-size: 18px; font-weight: 600; }
        .ci-pop p { margin: 0 0 18px; }
        .ci-pop .ci-actions { display:flex; justify-content:flex-end; gap:12px; }
        .ci-pop .ci-btn {
          appearance: none; border: 0; background: #000; color: #fff;
          padding: 12px 18px; border-radius: 0; cursor: pointer; font-weight: 600;
        }
        .ci-pop .ci-btn:focus { outline: 2px solid #000; outline-offset: 2px; }
        .ci-pop a { color: inherit; text-decoration: underline; }
      `;
      const style = document.createElement('style');
      style.id = 'ci-backorder-popup-styles';
      style.textContent = css;
      document.head.appendChild(style);
    }

    const message = submitBtn.dataset.backorderMessage || "This item is currently unavailable for your quantity. We may have it on backorder or can produce it with a lead time — email us to explore options!";

    // HTML
    const overlay = document.createElement('div');
    overlay.className = 'ci-pop-overlay';
    overlay.id = 'ci-backorder-popup';
    overlay.innerHTML = `
      <div class="ci-pop" role="dialog" aria-modal="true" aria-labelledby="ci-pop-title">
        <h3 id="ci-pop-title">Heads up</h3>
        <p id="ci-pop-msg">${message}</p>
        <div class="ci-actions">
          <button type="button" class="ci-btn" id="ci-pop-ok">OK</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);


    // Close handlers
    const close = () => { 
      overlay.style.display = 'none'; 
      document.body.style.overflow = ''; // ✅ restaura scroll
      submitBtn?.focus(); 
    };

    overlay.querySelector('#ci-pop-ok').addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (overlay.style.display === 'flex' && (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault(); 
        close();
      }
    });

  }

  function openBackorderModal() {
  ensureBackorderModal();
  const overlay = document.getElementById('ci-backorder-popup');
  overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden'; // 🚫 bloquea scroll
  overlay.querySelector('#ci-pop-ok').focus();
}

  function close() {
    const overlay = document.getElementById('ci-backorder-popup');
    overlay.style.display = 'none';
    document.body.style.overflow = ''; // ✅ restablece scroll
    submitBtn?.focus();
  }

  function handleBackorder() {
    const variantId = parseInt(variantInput.value);
    const vendor = window.productData.vendor;
    const inventoryPolicy = submitBtn.dataset.inventoryPolicy;
    const remaining = parseInt(submitBtn.dataset.remainingInventory || "0");
    const total = parseInt(submitBtn.dataset.totalPieces || "0");

    const variant = window.productData.variants.find(v => v.id === variantId);
    if (!variant || !vendor || isNaN(remaining) || isNaN(total)) return;

    const isVendorMatch = backorderVendors.includes(vendor);
    const isBackorder = (
      (total > remaining && inventoryPolicy === "deny") ||
      (total === 0 && inventoryPolicy === "deny")
    );

    if (isVendorMatch && isBackorder) {
      labelSpan.textContent = "ON BACKORDER";
      submitBtn.disabled = false;
      submitBtn.removeAttribute("disabled");
      submitBtn.setAttribute("aria-disabled", "false");
      submitBtn.classList.remove("disabled", "is-disabled");
      submitBtn.style.pointerEvents = "auto";
      submitBtn.style.opacity = "1";

      // Show modal instead of alert
      submitBtn.onclick = (e) => {
        e.preventDefault();
        openBackorderModal();
      };
    } else {
      labelSpan.textContent = "ADD TO CART";
      // Restore default behavior
      submitBtn.onclick = null;
    }
  }

  document.addEventListener("backorderCheck", handleBackorder);
  variantInput.addEventListener("change", () => setTimeout(handleBackorder, 50));
  qtyInput.addEventListener("change", () => setTimeout(handleBackorder, 50));

  // initial check (por si ya hay datos cargados)
  setTimeout(handleBackorder, 0);
})();